import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { isLoaded, isEmpty } from 'react-redux-firebase';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import Button from '@material-ui/core/Button';
import UndoIcon from '@material-ui/icons/Undo';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import classNames from 'classnames';
import Strings from 'components/Strings';
import { withStyles } from '@material-ui/core/styles';
import './wish.css';

const styles = theme => ({
  container: {
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap'
  },
  buyButton: {
    textAlign: 'right',
    marginRight: theme.spacing.unit
  },
  leftIcon: {
    marginRight: theme.spacing.unit
  }
});

class Wish extends Component {

  static propTypes = {
    wishId: PropTypes.string,
    isAdmin: PropTypes.bool,
    wish: PropTypes.object,
    isEditing: PropTypes.bool,
    edits: PropTypes.object,
    userId: PropTypes.string,
    whoWillBuy: PropTypes.string,
    language: PropTypes.string,

    onDelete: PropTypes.func,
    onEdit: PropTypes.func,
    onChange: PropTypes.func,
    onSave: PropTypes.func,
    onCancel: PropTypes.func
  }

  handleDelete = () => {
    const { onDelete } = this.props;
    onDelete && onDelete();
  }

  handleEdit = () => {
    const { onEdit } = this.props;
    onEdit && onEdit();
  }

  handleWillBuy = () => {
    const { wishId, userId, firebase } = this.props;

    if (!userId) {
      this.props.firebase.login({
        provider: 'google',
        type: 'popup'
      }).then(this.handleWillBuy);

      return;
    }

    const created = firebase.database.ServerValue.TIMESTAMP;
    const modified = created
    firebase.set(`willBuys/${wishId}`, { wishId, userId, created, modified });
  }

  handleCancelWillBuy = () => {
    const { wishId, firebase } = this.props;
    firebase.remove(`willBuys/${wishId}`);
  }

  renderAdmin = () =>
    <div className="Wish-Admin">
      <IconButton className="Wish-delete" onClick={ this.handleDelete } key="delete">
        <DeleteIcon />
      </IconButton>

      <IconButton className="Wish-edit" onClick={ this.handleEdit } key="edit">
        <EditIcon />
      </IconButton>
    </div>

  renderDescription() {
    const { wish, language } = this.props;
    const description = wish[`description_${language}`]

    return (
      description && (
      <div className="Wish-description">
        {
          description.split('\n').map((line, index) => <p key={ index }>{ line }</p>)
        }
      </div>)
    );
  }

  renderWillBuy() {
    const { whoWillBuy, userId, wish, classes } = this.props;
  
    switch (whoWillBuy) {
      case null:
        return (
          <div className="Wish-Reserve">
            <Button
              onClick={ this.handleWillBuy }
              variant="contained"
              color="secondary"
              className={ classes.reserveButton }
              key="reserve">
              <Strings label="reserve" />
            </Button>
          </div>
        );
      case userId:
        return (
          <div className="Wish-WillBuy">
            <Button
              onClick={ () => window.open(wish.url) }
              variant="contained"
              color="primary"
              className={ classes.buyButton }
              key="buyOnline">
              <ShoppingCartIcon fontSize="small" className={ classes.leftIcon } />
              <Strings label="buy_online" />
            </Button>

            <Button
              onClick={ this.handleCancelWillBuy }
              variant="contained"
              color="secondary"
              key="cancel">
              <UndoIcon fontSize="small" className={ classes.leftIcon } />
              <Strings label="cancel" />
            </Button>
          </div>
        );
      default:
        return (
          <div className="Wish-WillBuy">
            <span><Strings label="someone_will_buy" /></span>
          </div>
        );
    }
  }

  renderLinkAndPrice() {
    const { wish } = this.props;

    return (
      <a className="Wish-LinkAndPrice" href={ wish.url } target="_blank">
        <span className="Wish-StoreName"><ShoppingCartIcon />{ wish.storeName }</span>
        <span className="Wish-Price">{ wish.currency === 'euro' ? '€' : '₪' }{ wish.price }</span>
      </a>
    );
  }

  renderWish() {
    const { wish, isAdmin, whoWillBuy, userId, language} = this.props

    const classes = classNames("Wish", {
      willBuy: whoWillBuy === userId,
      hidden: !wish.visible
    });

    return (
      <div className={ classes }>
        <h1 className="Wish-title">{ wish[`title_${language}`] }</h1>

        {
          wish.imageUrl && (
            <span className="Wish-image">
              <img src={ wish.imageUrl } alt={ wish.title } />
            </span>
          )
        }

        { this.renderDescription() }
        
        { this.renderWillBuy() }

        { this.renderLinkAndPrice() }

        { isAdmin && this.renderAdmin() }
      </div>
    )
  }

  render() {
    const { wish } = this.props

    return isLoaded(wish) && !isEmpty(wish) && this.renderWish();
  }
}

export default withStyles(styles)(Wish);



// WEBPACK FOOTER //
// ./src/components/Wish/Wish.js